import {
    callUserInformation,
    selectUser,
    setLogin,
    setLogout,
    setOnboardingSteps,
    setShopPurchased,
    setUpdateUser,
    updateLoading,
} from "./userSlice"
import { useDispatch, useSelector } from "react-redux"
import {
    ACCEPT_AGREEMENT,
    ACCOUNT_TYPE,
    ADD_REFERRAL,
    CHANGE_PASSWORD,
    DASHBOARD_SHOP_PURCHASED,
    FETCH_LATEST_USER_DATA,
    FORGET_PASSWORD,
    FORGET_PASSWORD_REQUEST,
    GAMEZ_BOOST_AUTH,
    GENERATE_GOOGLE_2FA,
    GET_PROFILE,
    GET_REF_ID,
    LOGIN,
    NOTIFICATIONS_SETTINGS,
    POST_VERIFY,
    PROFILE_STEPS,
    RECENT_DEVICES,
    REGISTER,
    RETRY_USER_VERIFICATION,
    SEND_OTP,
    SET_SECURITY_CODE,
    UPDATE_EMAIL,
    UPDATE_PROFILE,
    UPDATE_PROFILE_PICTURE,
    USER_STATUS,
    VERIFYING_EMAIL,
    VERIFY_DOCS,
    VERIFY_EMAIL,
    VERIFY_GOOGLE2FA,
    VIEW_SECURITY_CODE,
} from "../../utils/network/ApiEndpoints"
import ApiRequest from "../../utils/network/ApiRequest"
//API
import { useNavigate } from "react-router-dom"
import { useNotificationsActions } from "../notifications/notificationsAction"

export const useUserActions = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const user = useSelector(selectUser)
    const { getUserActivity } = useNotificationsActions()

    const userLogin = async ({
        email,
        password,
    }: {
        email: string
        password: string
    }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: LOGIN,
                data: {
                    email,
                    password,
                },
            })
            .then((response: any) => {
                const { data } = response
                dispatch(
                    setLogin({
                        accessToken: data.data.token,
                        user: data.data.user,
                    })
                )

                return response
            })
            .catch((error: any) => {
                return error
            })
    }

    const userSignup = async (data: {
        email: string
        username: string
        password: string
        confirmPassword: string
        referralCode: string
        accept_terms: boolean
        accountType: string
    }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: REGISTER,
                data,
            })
            .then((response: any) => {
                const { data } = response

                dispatch(
                    setLogin({
                        accessToken: data.data.token,
                        user: data.data.user,
                    })
                )

                return response
            })
            .catch((error: any) => error)
    }

    const accountType = async ({
        type,
        email,
    }: {
        type: string
        email: string
    }) => {
        return await ApiRequest()
            .request({
                method: "PATCH",
                url: ACCOUNT_TYPE,
                data: {
                    type,
                    email,
                },
            })
            .then((response: any) => {
                fetchLatestUserData()
                return response
            })
            .catch((error: any) => error)
    }

    const addRefferal = async ({
        referralCode,
        email,
    }: {
        referralCode: string
        email: string
    }) => {
        return await ApiRequest()
            .request({
                method: "PATCH",
                url: ADD_REFERRAL,
                data: {
                    referralCode,
                    email,
                },
            })
            .then((response: any) => {
                const { data } = response

                fetchLatestUserData()

                return response
            })
            .catch((error: any) => error)
    }

    const getReferral = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: GET_REF_ID,
            })
            .then((response: any) => {
                const { data } = response

                return response
            })
            .catch((error: any) => error)
    }

    const getUserProfiles = async () => {
        dispatch(callUserInformation())

        return await ApiRequest()
            .request({
                method: "GET",
                url: GET_PROFILE,
            })
            .then((response: any) => {
                console.log(
                    "🚀 ~ getUserProfiles ~ response.data.data:",
                    response.data.data
                )
                const profile = response.data.data

                dispatch(setUpdateUser({ user: profile }))
                return response
            })
            .catch((error: any) => error)
    }

    const retryVerification = async () => {
        dispatch(updateLoading({ key: "retryKycLoading", value: true }))
        return await ApiRequest()
            .request({
                method: "POST",
                url: RETRY_USER_VERIFICATION,
            })
            .then((response: any) => {
                dispatch(
                    updateLoading({ key: "retryKycLoading", value: false })
                )
                getUserProfiles()
                return response
            })
            .catch((error: any) => {
                dispatch(
                    updateLoading({ key: "retryKycLoading", value: false })
                )
                return error
            })
    }

    const checkUserStatus = async () => {
        return ApiRequest()
            .request({
                method: "POST",
                url: LOGIN,
            })
            .then((response: any) => {
                const { user } = response.data.data
                fetchLatestUserData()
                return response
            })
            .catch((error: any) => error)
    }

    const userLogout = async () => {
        dispatch(setLogout())
        navigate("/auth/login")
        window.location.reload()
    }

    const userForgetPasswordRequest = async (email: string) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: FORGET_PASSWORD_REQUEST,
                data: {
                    email,
                },
            })
            .then((response: any) => response)
            .catch((error: any) => error)
    }

    const userForgetPassword = async ({
        newPassword,
        confirmPassword,
        token,
    }: {
        newPassword: any
        confirmPassword: any
        token: any
    }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: FORGET_PASSWORD,
                data: {
                    newPassword,
                    confirmPassword,
                    token,
                },
            })
            .then((response: any) => response)
            .catch((error: any) => error)
    }

    const sendOTP = async ({ email }: { email: any }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: SEND_OTP,
                data: {
                    email,
                },
            })
            .then((response: any) => response)
            .catch((error: any) => error)
    }

    const verifyEmail = async ({ otp, email }: { otp: any; email: any }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: VERIFY_EMAIL,
                data: {
                    otp,
                    email,
                },
            })
            .then((response: any) => {
                const {
                    data: { user },
                } = response.data

                // dispatch(setUpdateUser({user: user}))

                dispatch(setUpdateUser({ user: user }))
                // fetchLatestUserData()

                return response
            })
            .catch((error: any) => error)
    }

    const updateUserProfile = async (formData) => {
        // OTP send to database for storage
        return await ApiRequest()
            .request({
                method: "PATCH",
                url: UPDATE_PROFILE,
                data: formData,
            })
            .then((response: any) => {
                const user = response.data.data
                fetchLatestUserData()
                return response
            })
            .catch((error: any) => error)
    }
    const updateProfilePicture = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "POST",
                url: UPDATE_PROFILE_PICTURE,
            })
            .then((response: any) => {
                const { user } = response.data.data

                fetchLatestUserData()

                return response
            })
            .catch((error: any) => error)
    }

    // Profile Section Update Email Api

    const ChangeEmail = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "PATCH",
                url: UPDATE_EMAIL,
            })
            .then((response: any) => {
                fetchLatestUserData()
                return response
            })
            .catch((error: any) => error)
    }

    // Profile Section Update Password Api

    const changePassword = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "PATCH",
                url: CHANGE_PASSWORD,
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    // Profile Section Security Api

    const generateGoogle2fa = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: GENERATE_GOOGLE_2FA,
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    const verifyGoogle2fa = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "POST",
                url: VERIFY_GOOGLE2FA,
            })
            .then((response: any) => {
                fetchLatestUserData()
                return response
            })
            .catch((error: any) => error)
    }

    const setSecurityCode = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "POST",
                url: SET_SECURITY_CODE,
            })
            .then((response: any) => {
                fetchLatestUserData()

                return response
            })
            .catch((error: any) => error)
    }

    // Profile Section Notifications Api
    const notificationsSettings = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "PATCH",
                url: NOTIFICATIONS_SETTINGS,
            })
            .then((response: any) => {
                fetchLatestUserData()

                return response
            })
            .catch((error: any) => error)
    }

    // Recent Devices Section Notifications Api
    const getRecentDevices = async (params) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: RECENT_DEVICES,
                params,
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    //  KYC Section Api
    const verificationDocs = async (data) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: VERIFY_DOCS,
                data: data,
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    const PostVerification = async (data) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: POST_VERIFY,
                data: data,
            })
            .then((response: any) => {
                fetchLatestUserData()
                return response
            })
            .catch((error: any) => error)
    }

    // Other Api's
    const verifyingEmail = async (data) => {
        return await ApiRequest()
            .request({
                data: data,
                method: "POST",
                url: VERIFYING_EMAIL,
            })
            .then((response: any) => response)
            .catch((error: any) => error)
    }

    const onboardingSteps = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: PROFILE_STEPS,
            })
            .then((response: any) => {
                dispatch(setOnboardingSteps(response?.data?.data))
                return response
            })
            .catch((error: any) => error)
    }

    const fetchLatestUserData = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: FETCH_LATEST_USER_DATA,
            })
            .then((res: any) => {
                dispatch(setUpdateUser({ user: res.data.data }))
                return res
            })
            .catch((error: any) => error)
    }

    const getShopPurchased = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: DASHBOARD_SHOP_PURCHASED,
            })
            .then((res: any) => {
                dispatch(setShopPurchased(res.data.data))
            })
            .catch((error: any) => error)
    }

    const viewSecurityCode = async (otp) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: VIEW_SECURITY_CODE,
                data: { otp },
            })
            .then(async (res: any) => {
                await fetchLatestUserData()
                return res
            })
            .catch((error: any) => error)
    }

    const userAcceptAgreement = async () => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: ACCEPT_AGREEMENT,
            })
            .then((response: any) => {
                dispatch(
                    setUpdateUser({ user: { ...user, acceptAgreement: true } })
                )
                return response
            })
            .catch((error: any) => error)
    }

    const getGamezBoostAuth = async () => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: GAMEZ_BOOST_AUTH,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "User-Agent": "gameovate/1.0",
                },
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    return {
        userLogin,
        checkUserStatus,
        userLogout,
        userSignup,
        accountType,
        addRefferal,
        getReferral,
        userForgetPasswordRequest,
        userForgetPassword,
        sendOTP,
        verifyEmail,
        setSecurityCode,
        viewSecurityCode,
        updateUserProfile,
        changePassword,
        ChangeEmail,
        verifyGoogle2fa,
        verifyingEmail,
        updateProfilePicture,
        generateGoogle2fa,

        notificationsSettings,

        getRecentDevices,

        verificationDocs,
        PostVerification,

        onboardingSteps,
        fetchLatestUserData,

        getShopPurchased,
        getUserProfiles,
        retryVerification,
        userAcceptAgreement,
        getGamezBoostAuth,
    }
}
